import * as React from "react"

function ClockSVGIcon(props) {
    return (
        <svg
            id="prefix__Capa_1"
            x={0}
            y={0}
            viewBox="0 0 41.301 41.301"
            xmlSpace="preserve"
            {...props}
        >
            <path
                d="M20.642 0c5.698 0 10.857 2.317 14.602 6.047 3.73 3.746 6.047 8.905 6.047 14.603s-2.317 10.857-6.047 14.603c-3.746 3.73-8.904 6.047-14.602 6.047S9.786 38.983 6.056 35.253A20.572 20.572 0 01.008 20.65 20.573 20.573 0 016.055 6.047 20.576 20.576 0 0120.642 0zm10.524 19.523c.619 0 1.111.508 1.111 1.127s-.492 1.127-1.111 1.127H20.642c-.413 0-.778-.238-.968-.571l-.016-.016-.016-.032v-.016l-.016-.032-.016-.032v-.016l-.016-.032-.016-.016v-.032l-.016-.032v-.016l-.016-.032v-.064l-.016-.016V7.206c0-.619.492-1.111 1.111-1.111s1.127.492 1.127 1.111v12.317h9.398zm2.491-11.888c-3.333-3.333-7.936-5.381-13.015-5.381S10.96 4.301 7.627 7.635A18.408 18.408 0 002.246 20.65c0 5.079 2.063 9.682 5.381 13.016 3.333 3.333 7.936 5.381 13.015 5.381s9.682-2.048 13.015-5.381a18.355 18.355 0 005.397-13.016 18.35 18.35 0 00-5.397-13.015z"
                fill="#1e201d"
            />
        </svg>
    )
}

export default ClockSVGIcon
